var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91406 11.0979C6.91406 10.155 7.68789 9.39062 8.64246 9.39062H25.9264C26.881 9.39062 27.6548 10.155 27.6548 11.0979V14.5126C27.6548 15.4555 26.881 16.2199 25.9264 16.2199H8.64246C7.68789 16.2199 6.91406 15.4555 6.91406 14.5126V11.0979Z",
    fill: "#05F29B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9264 11.0979H8.64246L8.64246 14.5126H25.9264V11.0979ZM8.64246 9.39062C7.68789 9.39062 6.91406 10.155 6.91406 11.0979V14.5126C6.91406 15.4555 7.68789 16.2199 8.64246 16.2199H25.9264C26.881 16.2199 27.6548 15.4555 27.6548 14.5126V11.0979C27.6548 10.155 26.881 9.39062 25.9264 9.39062H8.64246Z",
    fill: "#1B1E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1232 33.2933H25.9257V36.7079H50.1232V33.2933ZM25.9257 31.5859C24.9711 31.5859 24.1973 32.3503 24.1973 33.2933V36.7079C24.1973 37.6508 24.9711 38.4152 25.9257 38.4152H50.1232C51.0778 38.4152 51.8516 37.6508 51.8516 36.7079V33.2933C51.8516 32.3503 51.0778 31.5859 50.1232 31.5859H25.9257Z",
    fill: "#1B1E59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3093 45.2434H39.7538L39.7538 48.6581H55.3093V45.2434ZM39.7538 43.5361C38.7992 43.5361 38.0254 44.3005 38.0254 45.2434V48.6581C38.0254 49.601 38.7992 50.3654 39.7538 50.3654H55.3093C56.2639 50.3654 57.0377 49.601 57.0377 48.6581V45.2434C57.0377 44.3005 56.2639 43.5361 55.3093 43.5361H39.7538Z",
    fill: "#1B1E59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2221 57.1956H55.3085L55.3085 60.6102H62.2221V57.1956ZM55.3085 55.4883C54.3539 55.4883 53.5801 56.2527 53.5801 57.1956V60.6102C53.5801 61.5532 54.3539 62.3175 55.3085 62.3175H62.2221C63.1766 62.3175 63.9504 61.5532 63.9504 60.6102V57.1956C63.9504 56.2527 63.1766 55.4883 62.2221 55.4883H55.3085Z",
    fill: "#1B1E59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5795 21.3421H19.0116V24.7567H53.5795V21.3421ZM19.0116 19.6348C18.057 19.6348 17.2832 20.3992 17.2832 21.3421V24.7567C17.2832 25.6996 18.057 26.464 19.0116 26.464H53.5795C54.5341 26.464 55.3079 25.6996 55.3079 24.7567V21.3421C55.3079 20.3992 54.5341 19.6348 53.5795 19.6348H19.0116Z",
    fill: "#1B1E59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.864318 0C1.3416 0 1.72852 0.382196 1.72852 0.853659L1.72852 68.2927H0.000120521L0.000120521 0.853659C0.000120521 0.382196 0.387035 0 0.864318 0Z",
    fill: "#1B1E59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1358 70.0003H0L0 68.293H69.1358C69.6131 68.293 70 68.6752 70 69.1466C70 69.6181 69.6131 70.0003 69.1358 70.0003Z",
    fill: "#1B1E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGant);
export default __webpack_public_path__ + "static/media/Icon_Gant.6d7f8c03ee670ae614c37f461a45e708.svg";
export { ForwardRef as ReactComponent };